/*
 * Copyright 2026 Hypergiant Galactic Systems Inc. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
'use client';
import 'client-only';

import { clsx } from '@accelint/design-foundation/lib/utils';
import { Badge } from '../badge';
import styles from './styles.module.css';
import type { KanbanMenuProps } from './types';

/**
 * KanbanColumnHeaderActions - Container for column actions
 *
 * Displays card count badge and optional action buttons.
 *
 * @param props - {@link KanbanMenuProps}
 * @param props.className - Optional CSS class name.
 * @param props.cardCount - Number of cards to display in badge.
 * @param props.children - Additional action elements.
 * @returns The rendered KanbanColumnHeaderActions component.
 */
export function KanbanColumnHeaderActions({
  className,
  cardCount,
  children,
  ...rest
}: KanbanMenuProps) {
  return (
    <div {...rest} className={clsx(styles.colHeaderActions, className)}>
      <Badge>{cardCount ?? 0}</Badge>
      {children}
    </div>
  );
}
